// extracted by mini-css-extract-plugin
export var banner = "_eg-0";
export var closeButton = "_eg-2";
export var greenCheckmark = "_eg-3";
export var hereLink = "_eg-4";
export var titleIcon = "_eg-1";